import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteTareaDto } from '@models/expedienteTarea/expedienteTareaDto.model';
import { TareaDto } from '@models/tarea/tareaDto.model';
import { ExpedienteTareaService } from '@services/expedienteTarea/expedienteTarea.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TareaService } from '@services/tarea/tarea.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BaseDto } from '@models/base/baseDto.model';
import { TareaFilter } from '@models/tarea/tareaFilter.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonNewComponent } from 'src/app/component/button-new/button-new.component';
import { SinDatosParaMostrarComponent } from 'src/app/component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { ButtonFilterTableComponent } from 'src/app/component/button-filter-table/button-filter-table.component';
import { MatSelectModule } from '@angular/material/select';
import { TableroKanbanComponent } from './tablero-kanban-tareas/tableroKanban.component';
import { ButtonActionComponent } from 'src/app/component/button-action/button-action.component';
import { AvatarInicialesComponent } from 'src/app/component/avatar-iniciales/avatar-iniciales.component';
import { ButtonFilterTableClearComponent } from 'src/app/component/button-filter-table-clear/button-filter-table-clear.component';
import { DialogFormTareaComponent } from '../dialog-form-tarea/dialog-form-tarea.component';
import { DialogParams } from 'src/app/interfaces/dialogParam.interface.model';
import { TiposTareaService } from '@services/tipoTarea/tipoTarea.service';
import { EstadoTareaService } from '@services/estadoTarea/estadoTarea.service';
import { SelectUsuariosEmpresaComponent } from 'src/app/component/select-usuarios-empresa/select-usuarios-empresa.component';


@Component({
  standalone: true,
  imports: [SinDatosParaMostrarComponent, ButtonNewComponent, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule,
    MatDividerModule, NgxSpinnerModule, MatTableModule,
    MatSliderModule, MatSlideToggleModule, MatMenuModule,
    MatDialogModule, MatDatepickerModule, MatExpansionModule,
    FormsModule, AppRolesDirective, MatSortModule, MatTooltipModule,
    MatPaginatorModule, MatRippleModule, CommonModule, ButtonFilterTableComponent, FormsModule, MatNativeDateModule, MatSelectModule, TableroKanbanComponent, AvatarInicialesComponent, ButtonFilterTableClearComponent, SelectUsuariosEmpresaComponent],
  selector: 'app-list-tarea',
  templateUrl: './list-tarea.component.html',
  styleUrls: ['./list-tarea.component.css']
})
export class ListTareaComponent {

  @Input() idExpediente!: number
  data = false
  esVistaTabla = true
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<TareaDto>();
  formBuilder = new FormBuilder
  formFilter: any;
  checkedFiltroAvanzado: boolean = false;
  lstEstados: BaseDto[] = [
    { id: 1, descripcion: 'Pendiente' },
    { id: 2, descripcion: 'En Proceso' },
    { id: 3, descripcion: 'Finalizado' },
  ];
  lstPrioridades: BaseDto[] = [
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];

  lstNiveles: BaseDto[] = [
    { id: 0, descripcion: 'Todos' },
    { id: 1, descripcion: 'Baja' },
    { id: 2, descripcion: 'Media' },
    { id: 3, descripcion: 'Alta' },
  ];
  tareaFilter!: TareaFilter;
  tareas!: TareaDto[];
  filtro: TareaFilter = new TareaFilter;
  filtroTareasGuardado!: string | null;

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;
  estadosTarea!: BaseDto[];
  tiposTarea!: BaseDto[];
  accionesDialog = AccionesDialog;
  listadoTareas!: TareaDto[];
  @Output() listadoTareasEmitter = new EventEmitter<TareaDto[]>();

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }
  constructor(
    private tareaService: TareaService,
    private snackBar: SnackBarService,
    private tipoTareaService: TiposTareaService,
    private estadoTareaService: EstadoTareaService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {

    this.formFilter = this.formBuilder.group({
      Titulo: [''],
      Descripcion: [''],
      FechaModificacionDesde: [null],
      FechaModificacionHasta: [null],
      FechaAltaDesde: [null],
      FechaAltaHasta: [null],
      IdsEstadoTarea: [[]],
      IdsTipoTarea: [[]],
      IdsTareaPadre: [[]],
      AsignadoA: [[]],
      CreadoPor: [[]],
      ModificadoPor: [[]],
      AutorizadoPor: [[]],
      Prioridad: [null],
      NivelAvance: [null],
      Notificado: [null],
      IdExpediente: [null]
    });

  }



  ngOnInit(): void {
    this.getAllTiposTarea()
    this.getAllEstadosTarea()

    if (this.idExpediente) {
      this.aplicarFiltro()
      this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.displayedColumns = result.matches ?
          ["titulo", "accion"] :
          ["titulo", "tipoTarea", "fechaAlta", "nivelAvance", "prioridad", "estado", "creadoPor", "asignadoA", "estados", "accion"];
      });
    }
    else {
      this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
        this.displayedColumns = result.matches ?
          ["titulo", "accion"] :
          ["titulo", "tipoTarea", "fechaAlta", "nivelAvance", "prioridad", "estado", "creadoPor", "asignadoA", "estados", "accion"];
      });
    }

    // this.dataSource.paginator = this.paginator;

    // this.dataSource.filterPredicate = (data: TareaDto, filter: string) => {
    //   return data.titulo.toLowerCase().includes(filter.trim().toLowerCase());
    // };

    //  if (this.idExpediente) {
    //   this.formFilter.controls['IdExpediente'].setValue(this.idExpediente);
    //   this.guardarFiltro()
    //   this.aplicarFiltro()
    // }

    // this.filtroTareasGuardado = localStorage.getItem('filtroTareasGuardado');
    // if (this.filtroTareasGuardado) {
    //   this.filtro = JSON.parse(this.filtroTareasGuardado);
    //   this.formFilter.patchValue(this.filtro);
    // }
  }

  guardarFiltro() {
    this.filtro = this.formFilter.value;
    localStorage.setItem('filtroTareasGuardado', JSON.stringify(this.filtro));
  }

  onCreadoPorSeleccionado(usuario: any) {
    this.formFilter.get('CreadoPor')?.setValue(usuario.id);
  }

  onAprobadoPorSeleccionado(usuario: any) {
    this.formFilter.get('ModificadoPor')?.setValue(usuario.id);
  }


  limpiarFiltro() {
    this.formFilter.reset();
    localStorage.removeItem('filtroTareasGuardado');
  }

  aplicarFiltro(filtro: TareaFilter = this.formFilter.value) {

    this.getAllTareaFilter(this.filtro)
    this.guardarFiltro();
  }

  esHoy(fecha: string | Date): boolean {
    const hoy = new Date();
    const fechaFin = new Date(fecha);
    var esHoy = (
      hoy.getDate() === fechaFin.getDate() &&
      hoy.getMonth() === fechaFin.getMonth() &&
      hoy.getFullYear() === fechaFin.getFullYear()
    )
    return esHoy;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.filterPredicate = (data: TareaDto, filter: string) => {
      return data.titulo.toLowerCase().includes(filter.trim().toLowerCase());
    };
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }




  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }
  cambiarVista(event: any) {
    if (event.checked == true)
      this.esVistaTabla = true
    else
      this.esVistaTabla = false
  }


  getAllTiposTarea() {
    this.spinner.show("spTipoTarea")
    this.tipoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTipoTarea")
          this.tiposTarea = data
        },
        error => {
          this.spinner.hide("spTipoTarea")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosTarea() {
    this.spinner.show('spEstadosTarea')
    this.estadoTareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spEstadosTarea')
          this.estadosTarea = data
        },
        error => {
          this.spinner.hide('spEstadosTarea')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTarea() {
    this.spinner.show('spListado')
    this.tareaService.getAll()
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.tareas = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTareaFilter(tareaFilter: TareaFilter) {
    this.spinner.show('spListado')
    this.tareaService.getAllByFilter(tareaFilter)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.listadoTareas = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTareaByIdExpediente(idExpediente: number) {
    this.spinner.show('spListado')
    this.tareaService.getAllByIdExpediente(idExpediente)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad } = params;

    const data = {
      ...entidad,
      accion,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data

    switch (accion) {
      case AccionesDialog.Ver:
        dialogConfig.width = "70%"
        break;

      default:
        dialogConfig.width = "50%"
        break;
    }

    const dialogRef = this.dialog.open(DialogFormTareaComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (!result || !result.event) return;

      switch (result.event) {
        case AccionesDialog.Agregar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Modificar:
          this.aplicarFiltro()
          break;
        case AccionesDialog.Eliminar:
          this.aplicarFiltro()
          break;
        default:

          break;
      }

    });
  }
  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
